// Download helpers (JSON + PNG via html-to-image).
import { toPng } from "html-to-image";

function triggerDownload(filename, dataUrl) {
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export function downloadJSON(filename, obj) {
  const blob = new Blob([JSON.stringify(obj, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  triggerDownload(filename, url);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export async function exportPNG(ref, name, bg = "#0B0F10") {
  if (!ref?.current) return;
  try {
    const dataUrl = await toPng(ref.current, {
      backgroundColor: bg,
      pixelRatio: 2,
      cacheBust: true,
    });
    triggerDownload(`${name}.png`, dataUrl);
  } catch (e) {
    console.error("PNG export failed", e);
  }
}

// ─── Fase 17B · Bloque 4 — ShareCard export ──────────────────────────────
// Captures a 1200×675 ShareCard at pixelRatio 2 (so ~2400×1350). Waits for
// fonts to be ready first so the serif & mono families render crisply.
// Filename: propforge_{firmaSlug}_{planSlug}_{YYYYMMDD}.png
function slug(s) {
  return (s || "custom").toString().toLowerCase()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")
    .slice(0, 32) || "custom";
}

function todayCompact() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}${m}${day}`;
}

export async function exportShareCard(ref, { firmName, planName }) {
  if (!ref?.current) return;
  try {
    if (document.fonts?.ready) {
      try { await document.fonts.ready; } catch { /* noop */ }
    }
    // Give the SVG ring one frame to paint before capture.
    await new Promise(r => requestAnimationFrame(() => r()));
    const dataUrl = await toPng(ref.current, {
      backgroundColor: "#16130f",
      pixelRatio: 2,
      cacheBust: true,
      width: 1200,
      height: 675,
    });
    const filename = `propforge_${slug(firmName)}_${slug(planName)}_${todayCompact()}.png`;
    triggerDownload(filename, dataUrl);
  } catch (e) {
    console.error("ShareCard export failed", e);
  }
}
